import React, { Component } from 'react'
import { connect } from 'react-redux'
import { save } from '../actions/sites'
import { replace, push } from '../history'
import { Link } from 'react-router-dom'
import SchemaForm from '../components/SchemaForm'
import LoadingButton from '../components/ui/LoadingButton'

@connect(state => ({auth: state.auth}))
export default class NewSite extends Component {
  onSubmit = async (value) => {
    const {dispatch} = this.props
    const {data} = await dispatch(save(value))
    if (data.id) push(`/${data.id}`)

    return data
  }

  componentDidMount () {
    const {auth} = this.props
    const canAddSite = auth.account && auth.account.sites_available > 0

    // redirect if user cannot create new sites
    if (!canAddSite) {
      replace('/dashboard/upgrade')
    }
  }

  render () {
    const schema = {
      name: {
        type: 'string',
        config: {type: 'login'},
        attrs: {placeholder: 'Fridge Name'},
        help: 'You can change this at any time',
        required: true
      }
    }

    return <div className='login-window'>
      <h1 className='text-center'>Create a new Fridge</h1>
      <SchemaForm schema={schema} onSubmit={this.onSubmit} button={props =>
        <div>
          <LoadingButton className='btn-save' type='submit' ui={props.ui}>Save</LoadingButton>
          <Link to='/dashboard' className='btn btn-cancel'>Cancel</Link>
        </div>
      } />
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/NewSite.js